import { Link } from "react-router-dom";

export default function ArticleIndex() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        {/* Title */}
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            Latest Spreadsheet
          </h2>
          <h3 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 mt-1">
            Research Guides
          </h3>
          <p className="mt-3 text-sm text-foreground-500 max-w-md">
            Expert-written articles to help you master spreadsheet shopping
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {/* Article 1: Hipobuy Spreadsheet Guide */}
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="group rounded-2xl border border-background-200 overflow-hidden bg-background-50 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
          >
            {/* Cover */}
            <div className="aspect-[16/10] bg-background-100 flex items-center justify-center overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20colorful%20data%20spreadsheet%20on%20wooden%20desk%20with%20potted%20succulent%20plant%20and%20coffee%20mug%2C%20cozy%20home%20office%20at%20night%20with%20warm%20desk%20lamp%20glow%2C%20productive%20workspace%20lifestyle%20photography%2C%20soft%20bokeh%20background&width=640&height=400&seq=article-hipobuy-v2-01&orientation=landscape"
                alt="What Is Hipobuy Sheet? Complete Beginner's Guide 2026"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            {/* Info */}
            <div className="p-5 flex flex-col flex-1">
              <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                  Beginner Guide
                </span>
                <span>12 min read</span>
              </div>
              <h4 className="font-heading text-lg font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                What Is Hipobuy Sheet? Complete Beginner&apos;s Guide 2026
              </h4>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed flex-1">
                Everything you need to know about Hipobuy Spreadsheet — how it works, why thousands of shoppers use it daily, and how to get started with organized product discovery.
              </p>
              <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200">
                <span className="text-xs text-foreground-400">July 2026</span>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 whitespace-nowrap">
                  Read Full Guide <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </Link>

          {/* Placeholder: Hipobuy vs Kakobuy */}
          <div className="rounded-2xl border border-dashed border-secondary-300 overflow-hidden bg-secondary-50/60 flex flex-col hover:bg-secondary-100/70 transition-colors cursor-default">
            <div className="aspect-[16/10] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Two%20vintage%20wooden%20desks%20side%20by%20side%20with%20open%20leather%20notebooks%20and%20fountain%20pens%2C%20warm%20coffee%20shop%20interior%20with%20soft%20window%20light%2C%20comparison%20workspace%20scene%2C%20editorial%20still%20life%20photography%20with%20muted%20earth%20tones%20and%20shallow%20depth%20of%20field&width=640&height=400&seq=article-comingsoon-compare-01&orientation=landscape"
                alt="Hipobuy vs Kakobuy Spreadsheet Comparison"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-secondary-200/50 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-secondary-100/80 flex items-center justify-center backdrop-blur-sm">
                  <i className="ri-time-line text-3xl text-secondary-500"></i>
                </div>
              </div>
            </div>
            <div className="p-5 flex flex-col flex-1">
              <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                  Comparison
                </span>
                <span className="text-secondary-600 font-medium">Coming Soon</span>
              </div>
              <h4 className="font-heading text-lg font-semibold text-foreground-700 leading-snug">
                Hipobuy vs Kakobuy Spreadsheet Comparison
              </h4>
              <p className="mt-2 text-sm text-foreground-500">This guide is being written. Check back soon.</p>
              <div className="mt-auto pt-4 border-t border-secondary-200/60">
                <span className="inline-flex items-center gap-1 text-xs text-secondary-600 font-medium">
                  <i className="ri-time-line"></i> Coming Soon
                </span>
              </div>
            </div>
          </div>

          {/* Placeholder: Safety Guide */}
          <div className="rounded-2xl border border-dashed border-secondary-300 overflow-hidden bg-secondary-50/60 flex flex-col hover:bg-secondary-100/70 transition-colors cursor-default">
            <div className="aspect-[16/10] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20steel%20padlock%20resting%20on%20closed%20leather%20journal%20notebook%2C%20minimalist%20marble%20desk%20surface%20with%20soft%20morning%20sunlight%20streaming%20through%20blinds%2C%20security%20and%20privacy%20concept%20still%20life%20photography%20with%20clean%20neutral%20tones%20and%20gentle%20shadows&width=640&height=400&seq=article-comingsoon-safety-01&orientation=landscape"
                alt="How To Use Shopping Spreadsheets Safely"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-secondary-200/50 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-secondary-100/80 flex items-center justify-center backdrop-blur-sm">
                  <i className="ri-time-line text-3xl text-secondary-500"></i>
                </div>
              </div>
            </div>
            <div className="p-5 flex flex-col flex-1">
              <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                  Safety Guide
                </span>
                <span className="text-secondary-600 font-medium">Coming Soon</span>
              </div>
              <h4 className="font-heading text-lg font-semibold text-foreground-700 leading-snug">
                How To Use Shopping Spreadsheets Safely
              </h4>
              <p className="mt-2 text-sm text-foreground-500">This guide is being written. Check back soon.</p>
              <div className="mt-auto pt-4 border-t border-secondary-200/60">
                <span className="inline-flex items-center gap-1 text-xs text-secondary-600 font-medium">
                  <i className="ri-time-line"></i> Coming Soon
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}